import { Subscription } from '@cel_cash/core/types'
import DialogGuide from 'global/guides/Dialog'
import { useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { assinaturas } from 'service/api'
import tokenRefresher from 'service/api/token-refresher'
import { toast } from 'sonner'

type OutletContext = {
    assinatura?: Subscription
}

export default function CancelarAssinatura() {
    const { assinatura } = useOutletContext<OutletContext>()
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const handleSubmit = async () => {
        if (!assinatura) return

        setIsLoading(true)
        return assinaturas
            .delete('minha-assinatura')
            .then(async () => {
                toast.success('Assinatura cancelada com sucesso!')

                await Promise.all([
                    assinaturas.invalidateQueries(),
                    assinaturas.minhaAssinatura.invalidateQueries(),
                ])

                await tokenRefresher.refreshToken()
                navigate('/planos/me', { replace: true })
            })
            .catch(e => {
                toast.error(e.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <DialogGuide.Root
            width="auto"
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
        >
            <DialogGuide.Title>
                Tem certeza que deseja cancelar sua assinatura?
            </DialogGuide.Title>
            <DialogGuide.Content>
                Você perderá acesso ao sistema no final do período de
                faturamento atual.
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Não, voltar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton closeOnSubmit color="error">
                    Sim
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}
